import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ButtonBase } from '@material-ui/core';
import { GlobalHistory } from '../../../../../Helper';
import btnLoader from '../../../../../assets/images/GIF_images/btn-loader.gif';
import arrowLeft from '../../../../../assets/images/icons/arrow-left.png';
import { TrackEventService } from '../../../../../Helper/mixpanelHelper';

export const TransactionActionButtons = ({
  isSubmitDisabled,
  submitButton,
  backButtonHandler,
  isWithoutCancel,
  isWithBackButton,
  cancelRoute,
  parentTranslationPath,
  activeStep,
}) => {
  const translationPath = '';
  const { t } = useTranslation(parentTranslationPath);

  const eventMapping = {
    TenantSelection: {
      next: 'Leasing_journey_Tenant_Selection_Next_Button_Clicked',
      nextEnabled: 'Leasing_journey_Tenant_Selection_Next_Button_Enabled',
      cancel: 'Leasing_journey_Tenant_Selection_Cancel_Button_Clicked',
      back: 'Leasing_journey_Tenant_Selection_Back_Button_Clicked',
    },
    OfferLetterDispatch: {
      next: 'Leasing_journey_Offer_Letter_Dispatch_Send_Button_Clicked',
      nextEnabled: 'Leasing_journey_Offer_Letter_Dispatch_Send_Button_Enabled',
      cancel: 'Leasing_journey_Offer_Letter_Dispatch_Cancel_Button_Clicked',
      back: 'Leasing_journey_Offer_Letter_Dispatch_Back_Button_Clicked',
    },
    UnitReservations: {
      next: 'Leasing_journey_Unit_Reservation_Next_Button_Clicked',
      nextEnabled: 'Leasing_journey_Unit_Reservation_Next_Button_Enabled',
      cancel: 'Leasing_journey_Unit_Reservation_Cancel_Button_Clicked',
      back: 'Leasing_journey_Unit_Reservation_Back_Button_Clicked',
    },
    PaymentDetails: {
      next: 'Leasing_journey_Payment_Details_Next_Button_Clicked',
      nextEnabled: 'Leasing_journey_Payment_Details_Next_Button_Enabled',
      cancel: 'Leasing_journey_Payment_Details_Cancel_Button_Clicked',
      savePayment:
        'Leasing_journey_Payment_Details_Save_Payment_Button_Clicked',
      back: 'Leasing_journey_Payment_Details_Back_Button_Clicked',
    },
    ContractIssuance: {
      next: 'Leasing_journey_Contact_Issuance_Send_Button_Clicked',
      nextEnabled: 'Leasing_journey_Contact_Issuance_Send_Button_Enabled',
      cancel: null,
      back: 'Leasing_journey_Contact_Issuance_Back_Button_Clicked',
    },
    DepositAndFeesVerification: {
      next: 'Leasing_journey_Deposit_And_Fees_Verification_Send_Button_Clicked',
      nextEnabled:
        'Leasing_journey_Deposit_And_Fees_Verification_Send_Button_Enabled',
      cancel: null,
      back: 'Leasing_journey_Deposit_And_Fees_Verification_Back_Button_Clicked',
    },
  };

  const stepKey =
    activeStep && typeof activeStep === 'object' ? activeStep.key : activeStep;
  const currentEvents = eventMapping[stepKey] || {};

  useEffect(() => {
    if (!isSubmitDisabled && currentEvents.nextEnabled) {
      TrackEventService(currentEvents.nextEnabled, {
        page_name: stepKey,
        screen: stepKey,
      });
    }
  }, [isSubmitDisabled, currentEvents.nextEnabled, stepKey]);

  const cancelClickHandler = (event) => {
    event.preventDefault();
    if (currentEvents.cancel) {
      TrackEventService(currentEvents.cancel, {
        page_name: stepKey,
        screen: stepKey,
      });
    } else {
    }
    GlobalHistory.push(cancelRoute);
  };

  const saveHandler = (event) => {
    event.preventDefault();
    if (
      stepKey === 'PaymentDetails' &&
      submitButton.label.toLowerCase() === 'save'
    ) {
      TrackEventService(currentEvents.savePayment, {
        page_name: stepKey,
        screen: stepKey,
      });
    } else if (currentEvents.next) {
      TrackEventService(currentEvents.next, {
        page_name: stepKey,
        screen: stepKey,
      });
    }
    submitButton.handler();
  };

  const handleBackButton = (event) => {
    event.preventDefault();
    if (currentEvents.back) {
      TrackEventService(currentEvents.back, {
        page_name: stepKey,
        screen: stepKey,
      });
    }
    backButtonHandler();
  };

  return (
    <div>
      <div className='d-flex-center fj-end py-0 pt-3'>
        {isWithBackButton && (
          <ButtonBase
            onClick={handleBackButton}
            className='btns theme-propx transparent'
          >
            <img src={arrowLeft} alt='Back' />
            {t(`${translationPath}back`)}
          </ButtonBase>
        )}
        {!isWithoutCancel && (
          <ButtonBase
            onClick={cancelClickHandler}
            className='btns theme-propx outlined'
          >
            {t(`${translationPath}cancel`)}
          </ButtonBase>
        )}
        <ButtonBase
          className='btns theme-propx solid mr-0'
          onClick={saveHandler}
          disabled={isSubmitDisabled || submitButton.isLoading}
        >
          {t(`${translationPath}${submitButton.label}`)}
          {submitButton.isLoading && (
            <img src={btnLoader} className='ml-1' height='12' alt='Loading' />
          )}
        </ButtonBase>
      </div>
    </div>
  );
};

TransactionActionButtons.propTypes = {
  selected: PropTypes.object,
  submitButton: PropTypes.shape({
    label: PropTypes.string.isRequired,
    handler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
  }).isRequired,
  isSubmitDisabled: PropTypes.bool,
  isWithoutCancel: PropTypes.bool,
  cancelRoute: PropTypes.string,
  backButtonHandler: PropTypes.func,
  isWithBackButton: PropTypes.bool,
  parentTranslationPath: PropTypes.string,
  activeStep: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

TransactionActionButtons.defaultProps = {
  selected: {},
  submitButton: {
    label: 'next',
    handler: () => {},
    isLoading: false,
  },
  backButtonHandler: () => {},
  isWithoutCancel: false,
  isSubmitDisabled: false,
  isWithBackButton: false,
  cancelRoute: '/home/units-lease/view',
  parentTranslationPath: '',
  activeStep: '',
};
